<template>
  <v-dialog v-model="dialog" max-width="1376" scrollable persistent content-class="elevation-0">
    <v-overlay v-if="is_load" absolute color="white" opacity="0.3" z-index="12">
      <v-progress-circular indeterminate color="#1DBC97" size="100" width="8"></v-progress-circular>
    </v-overlay>
    <v-card class="rounded-xl">
      <v-card-title class="card-title-background-add-permission py-4 ">
        <v-row class="row-add-permission-hc" align="center">
          <v-spacer></v-spacer>
          <b class="front-add-permission-hc">สิทธิ์การใช้งาน</b>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialog = false" color="#ffffff">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="px-4 pb-4">
        <v-row class="row-add-permission-hc">
          <v-col cols="12" md="auto" lg="auto" class="px-0 pt-4 pb-0" align-self="center">
            <b class="front-text-apppermission-hc">ตารางแสดงรายการ</b>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="7" md="3" lg="3" class="px-0 pt-4 pb-0">
            <v-form ref="form" lazy-validation @submit.prevent="">
              <v-text-field outlined dense placeholder="@one.th" class="search-box-apppermission-hc" color="#1DBC97"
                background-color="white" v-model="user_input_email" value="user_input_email"
                @keyup.enter="addUserPermission(user_input_email)" :rules="email_rules" required>
              </v-text-field>
            </v-form>
          </v-col>
          <v-col cols="auto" md="auto" lg="auto" align-self="start" class="pt-4 pb-0 pr-0 pl-2">
            <v-btn height="40px" outlined color="#1DBC97" class="btn-search-apppermission-hc"
              @click="addUserPermission(user_input_email)" :disabled="!isValidEmail(user_input_email)">
              <v-icon left small>
                mdi-account-plus-outline
              </v-icon>
              เพิ่มสิทธิ์
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="row-add-permission-hc">
          <v-col cols="12" md="3" lg="3" class="pt-4 pb-0 px-0">
            <v-text-field prepend-inner-icon="mdi-magnify" outlined hide-details dense placeholder="ค้นหา"
              class="search-box-apppermission-hc" color="#1DBC97" background-color="white" v-model="search_keyword">
            </v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          class="mt-4 hc-data-table-add hc-data-table-add-border hc-data-table-add-header hide-hc-table-progress-add hc-data-table-add-table"
          :headers="data_table_headers" :items="data_table_items" :search="search_keyword" fixed-header>
          <template v-slot:[`item.delete`]="{ item }">
            <v-btn icon color="red" @click="openDeletePermissionDialog(item.email)">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
            <!-- <v-btn icon color="red" >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn> -->
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ item.date | shortmonthyearandtime }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <HCDashboardConfirmDeletePermissionVue />
  </v-dialog>
</template>

<script>
import { EventBus } from "../../EventBus";
import HCDashboardConfirmDeletePermissionVue from "./HCDashboardConfirmDeletePermission.vue";
export default {
  components: {
    HCDashboardConfirmDeletePermissionVue
  },
  data: () => ({
    dialog: false,
    data_table_headers: [
      { text: "วันที่สร้าง", align: "center", sortable: false, value: "date" },
      {
        text: "ชื่อ-นามสกุล",
        align: "center",
        sortable: false,
        value: "name"
      },
      {
        text: "One E-mail",
        align: "center",
        sortable: false,
        value: "email"
      },
      {
        text: "role",
        align: "center",
        sortable: false,
        value: "role"
      },
      { text: "", align: "start", sortable: false, value: "delete" }
    ],
    data_table_items: [],
    user_input_email: "",
    search_keyword: "",
    is_load: false,
    email_rules: [
      v => !v || /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@one\.th$/.test(v) || 'Invalid E-mail',
    ],
  }),
  mounted() {
    EventBus.$on(
      "FormHcDashBoardAddPermission",
      this.getHCDashboardAddPermission
    );
    EventBus.$on("FetchPermissionUsers", this.getUsers);
  },
  created() {
    this.accessToken = sessionStorage.getItem("access_token");
    this.getUsers();
  },
  beforeDestroy() {
    EventBus.$off("FetchPermissionUsers")
    EventBus.$off("FormHcDashBoardAddPermission")
  },
  methods: {
    isValidEmail(email) {
      const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@one\.th$/
      return pattern.test(email)
    },
    async getUsers() {
      try {
        this.is_load = true
        const url = this.$api_url + "/petty_cash/api/v1/get_table_email";
        const { data } = await this.axios.get(url);
        if (data.status) {
          this.data_table_items = data.data;
          this.$emit('send-data', data.data);
        }
      } catch (error) {
        console.log(error);
      }
      this.is_load = false
    },
    async addUserPermission(user_input_email) {
      try {
        if (this.isValidEmail(user_input_email)) {
          const url = this.$api_url + "/petty_cash/api/v1/add_hc_email";
          const { data } = await this.axios.post(url, {
            email: this.user_input_email
          });
          if (data.status) {
            this.showSuccessAlert()
            this.resetForm()
          } else {
            this.showUnsuccessAlert()
          }
        } else {
          this.showUnsuccessAlert()
        }
        this.getUsers()
      } catch (error) {
        const resMessage = (error.response.data.message)
        const duplicateMessage = "This Email is already in the Database"
        if (resMessage === duplicateMessage) {
          this.showDuplicateEmailAlert()
        } else {
          console.log(error)
        }
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    resetForm() {
      this.$refs.form.reset()
    },
    getHCDashboardAddPermission() {
      this.dialog = true;
      try {
        this.resetValidation()
      } catch (error) {
      }
    },
    openDeletePermissionDialog(userEmail) {
      EventBus.$emit("FormHcDashBoardConfirmDeletePermission", userEmail);
    },
    showSuccessAlert() {
      this.$swal({
        backdrop: false,
        position: 'top-end',
        width: '353px',
        title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z" fill="#4CAF1E"/></svg><b class="alert-success-title">เพิ่มสำเร็จ</b>',
        text: 'เพิ่มบัญชีเรียบร้อยแล้ว',
        showCloseButton: true,
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          container: 'alert-card-block',
          popup: 'alert-card-success',
          title: 'alert-title-block-v2',
          closeButton: 'alert-close-btn',
          htmlContainer: 'alert-text-box'
        }
      })
    },
    showUnsuccessAlert() {
      this.$swal({
        backdrop: false,
        position: 'top-end',
        width: '353px',
        title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1118_2932)"><path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17H12.01" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 11V14" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg><b class="alert-error-title">เพิ่มไม่สำเร็จ</b>',
        text: 'กรุณาลองใหม่ในภายหลัง',
        showCloseButton: true,
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          container: 'alert-card-block',
          popup: 'alert-card-error',
          title: 'alert-title-block-v2',
          closeButton: 'alert-close-btn',
          htmlContainer: 'alert-text-box'
        }
      })
    },
    showDuplicateEmailAlert() {
      this.$swal({
        backdrop: false,
        position: 'top-end',
        width: '353px',
        title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1118_2932)"><path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17H12.01" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 11V14" stroke="#C00C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg><b class="alert-error-title">เพิ่มไม่สำเร็จ</b>',
        text: 'E-mail นี้มีในระบบแล้ว',
        showCloseButton: true,
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          container: 'alert-card-block',
          popup: 'alert-card-error',
          title: 'alert-title-block-v2',
          closeButton: 'alert-close-btn',
          htmlContainer: 'alert-text-box'
        }
      })
    },

  }
};
</script>

<style>
.hide-hc-table-progress-add .v-data-table__progress {
  display: none;
}

.hc-data-table-add.v-data-table>.v-data-table__wrapper {
  max-height: calc(100vh - 369px) !important;
  overflow: auto;
}

.v-application--is-ltr .hc-data-table-add.v-data-table--fixed-header .v-data-footer {
  margin-right: 0% !important;
}

.theme--light .hc-data-table-add-border.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid #f3f5f7 !important;
}

.hc-data-table-add-border {
  border: 1px solid #f3f5f7;
  border-radius: 8px !important;
}

.hc-data-table-add-header.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #333333 !important;
  background: #f3f5f7;
  text-align: center !important;
  height: 40px !important;
  box-shadow: none !important;
}

.hc-data-table-add-table.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 14px !important;
  color: #464646 !important;
  height: 40px !important;
}

.between-btn-search-apppermission-hc {
  margin-left: auto !important;
}

.btn-search-apppermission-hc {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 14px !important;
  border-radius: 8px;
  border: 1px solid #e6e6e6 !important;
}

.search-box-apppermission-hc.v-text-field input {
  line-height: 17px !important;
}

.search-box-apppermission-hc {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 14px !important;
}

.front-text-apppermission-hc {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 16px !important;
  color: #333333;
}

.card-title-background-add-permission {
  background: #1dbc97;
  height: 56px;
}

.row-add-permission-hc {
  width: 100%;
  margin: 0% !important;
}

.front-add-permission-hc {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 16px !important;
  color: #ffffff;
  line-height: 22px;
}

/* ======================================================================== */

@media only screen and (max-width: 600px) {

  /*css for mobile screen*/
  .hc-data-table-add.v-data-table>.v-data-table__wrapper {
    max-height: calc(100vh - 420px) !important;
  }
}
</style>
